import type {
  GetCreditCardsUC,
  PaymentRepository,
} from "@phurshell/psiapp-frontend-core/domain";

export class GetCreditCards implements GetCreditCardsUC {
  constructor(private readonly paymentRepo: PaymentRepository) {}

  async execute(currentCardId?: string) {
    const data = await this.paymentRepo.getCreditCards();
    const favorite_card = await this.paymentRepo.getFavoriteCard(
      data,
      currentCardId,
    );
    return { data, favorite_card };
  }
}
